import { Tabs, Tab, Stack } from "@mui/material";
import React, { useEffect, useState } from "react";
import { majorRoutes } from '../../constants/majorRoutes';
import DownloadIcon from "@mui/icons-material/Download";
import PrintIcon from "@mui/icons-material/Print";
import DetailsCard from "../../components/card/DetailsCard";
import CustomTextField from "../../components/textfield/CustomTextField";
import {
  AppLayout,
  ArrowBackIosIcon,
  Box,
  CustomBackdrop,
  CustomButton,
  CustomConfirmDialog,
  Toaster,
  useApi,
  useLocation,
  useNavigate,
  useParams
} from "../../utils/globalImports";
import { Button, CircularProgress, Dialog, Grid2, IconButton, TextField, Typography } from "@mui/material";
import InvoiceFormTable from "../../components/dataTable/InvoiceFormTable";
import {
  defaultButtonStyles,
  headingStyles,
  subHeadingStyles
} from "../../assets/styles/CommonStyles";
import {
  CreateInvoiceResponse,
  FinancialSummary,
  InvoiceDetails,
  InvoiceFullDetails
} from "../../interfaces/Invoicing.interfaces";
import { InvoiceMode, InvoiceStatus } from "../../constants/constants";
import { useFormUnsavedChanges } from "../../hooks/useFormUnsavedChanges";
import { isProjectManager, isSMT } from "../../interfaces/userRoles";
import { ConfirmDialog } from "@toolpad/core";
import { ArrowForward } from "@mui/icons-material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import CloseIcon from "@mui/icons-material/Close";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import ListAltIcon from "@mui/icons-material/ListAlt";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import BuildIcon from "@mui/icons-material/Build";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";

const CreateInvoice: React.FC<any> = () => {
  const [data, setData] = useState<CreateInvoiceResponse[]>([]);
  const [loading, setLoading] = useState(true);
  const [isDirty, setIsDirty] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [actionType, setActionType] = useState<InvoiceStatus | null>(null);
  const [toast, setToast] = useState({ open: false, message: "", type: "success" });
  const [isClicked, setIsClicked] = useState(false);
  const [invoiceDetails, setInvoiceDetails] = useState<InvoiceDetails | null>(null);
  const [isValid, setIsValid] = useState(true);
  const [isRejected, setIsRejected] = useState<boolean>(false);
  const [isDialogOpen, setisDialogOpen] = useState<boolean>(false);
  const [Section, SetSection] = useState<[sectionId: number, sectionName: string][]>([]);
  const [ActiveSection, SetActiveSection] = useState<number>(1);
  const [dropOutReason, setDropOutReason] = useState("");
  const [dropOutAmount, setDropOutAmount] = useState(0);
  const { execute } = useApi();
  const navigate = useNavigate();
  const location = useLocation();
  const [value, setValue] = useState(0);
  const thisMonthSection = Section.find(s => s[1] === "This Month");
  const otherSections = Section.filter(s => s[1] !== "This Month");
  const { invoiceId, mode } = useParams();
  const isMultiInvoiceView = location.pathname.includes("viewinvoices");
  const selectedInvoiceTypes = location.state?.selectedInvoiceTypes || [];
  const forecast = location.state?.forecast;
  const allInvoices = location.state?.selectedInvoices || [];
  const submittedBy = Number(localStorage.getItem("userId"));
  const isCreated = !invoiceId;
  const invoiceMode: InvoiceMode =
    isMultiInvoiceView ? InvoiceMode.View : isCreated ? InvoiceMode.Edit : mode === "view" ? InvoiceMode.View : mode === "edit" ? InvoiceMode.Edit : InvoiceMode.View;
  const [invoiceIdState, setInvoiceIdState] = useState<number>(Number(invoiceId) > 0 ? Number(invoiceId) : 0);
  const isViewMode = invoiceMode == InvoiceMode.View;
  const [currentPage, setCurrentPage] = useState(0);
  const lastPage = data.length - 1;
  const [summary, setSummary] = useState<FinancialSummary | null>(null);
  const { ConfirmLeaveDialog } = useFormUnsavedChanges({
    isDirty: isViewMode ? false : isDirty,
    routesToBlock: majorRoutes
  });
  const [netIntoAccounts, setNetIntoAccounts] = useState<number>(0);
  const filterMonth = location.state?.filterMonth;
  const filterYear = location.state?.filterYear;
  const [ProjectID, setProjetID] = useState<number>(0);
  useEffect(() => {
    if (selectedInvoiceTypes.length <= 0 && invoiceIdState <= 0 && allInvoices.length <= 0) {
      navigate("/invoicing")
      if (isSMT()) {
        navigate('/invoiceList');
      }
      else if (isProjectManager()) {
        navigate(`/invoicing`);
      }
      else {
        navigate(`/project/projects`);
      }
    }
    if (thisMonthSection) {
      SetActiveSection(thisMonthSection[0]);
    }
  }, [Section]);

  useEffect(() => {
    if (allInvoices?.length > 0) {
      fetchInvoiceById(allInvoices[currentPage]);
      setInvoiceIdState(allInvoices[currentPage])
    } else if (invoiceId) {
      fetchInvoiceById(Number(invoiceId));
    } else {
      fetchForms();
    }
  }, [invoiceId, currentPage]);

  useEffect(() => {
  }, [location]);

  useEffect(() => {
    setIsDirty(false);
  }, [currentPage]);

  const fetchForms = async () => {
    const payload = selectedInvoiceTypes.flatMap(
      (item: { [key: number]: number[] }) =>
        Object.keys(item).map(projectId => ({
          projectId: Number(projectId),
          InvoiceTypeIds: item[Number(projectId)]
        }))
    );

    try {
      setLoading(true);
      const { data } = await execute<CreateInvoiceResponse[]>(
        "post",
        "Invoice/GetInvoiceForms",
        payload
      );
      if (data && data.length > 0) {
        setProjetID(data[0]?.projectId);
        setNetIntoAccounts(data[currentPage]?.netIntoAccounts ?? 0);
      }
      setData(data || []);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };


  const fetchInvoiceById = async (invoiceId: number) => {
    try {
      setLoading(true);
      const payload = {
        invoiceId: invoiceId,
        mode: invoiceMode
      }
      const { data } = await execute<InvoiceFullDetails>(
        "get",
        `Invoice/${invoiceId}`, payload
      );
      if (data && data.projectInvoiceForm.projectId > 0) {
        setProjetID(data.projectInvoiceForm.projectId)
      }
      if (!data) return;
      const { projectInvoiceForm, invoiceDetails } = data;
      setInvoiceDetails(invoiceDetails);
      setSummary(financialSummary => data.financialSummary);
      const combined: CreateInvoiceResponse = {
        invoiceId: invoiceDetails.invoiceId,
        projectId: projectInvoiceForm.projectId,
        projectName: projectInvoiceForm.projectName,
        InvoiceTypeIds: projectInvoiceForm.invoiceTypeIds,
        sections: projectInvoiceForm.sections,
        netIntoAccounts: invoiceDetails.netIntoAccounts,
        differnce: invoiceDetails.differnce,
        amountPermanentlyDropOut: invoiceDetails.amountPermanentlyDropOut,
        reasonOfDroppingOut: invoiceDetails.reasonOfDroppingOut || "",
        submittedBy: Number(invoiceDetails.submittedBy) ?? null,
        submittedByName: invoiceDetails.submittedByName ?? "",
        status: invoiceDetails.status as InvoiceStatus,
        ApprovedBy: Number(invoiceDetails.ApprovedBy) ?? null,
        financialSummary: data.financialSummary
      };
      setNetIntoAccounts(invoiceDetails.netIntoAccounts ?? 0);
      setDropOutAmount(invoiceDetails.amountPermanentlyDropOut);
      setData([combined]);
      setIsDirty(false);

    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };


  const handleSaveInvoice = () => {
    setActionType(InvoiceStatus.Submitted);
    setIsDirty(false);
    setDialogOpen(true);
  };

  const handleSaveInProgress = () => {
    setActionType(InvoiceStatus.Draft);
    setIsDirty(false);
    setDialogOpen(true);
  };

  const handleCancel = () => {
    setDialogOpen(false);
  };
  const saveInvoice = async () => {
    const currentInvoice = data[currentPage];
    if (!currentInvoice) return;

    try {
      setLoading(true);

      const payload = {
        ...currentInvoice,
        invoiceId: currentInvoice.invoiceId || 0,
        amountPermanentlyDropOut: dropOutAmount,
        reasonOfDroppingOut: dropOutReason,
        status: actionType,
        submittedBy
      };

      const { data: res } = await execute<number>(
        "post",
        "Invoice/CreateInvoice",
        payload
      );

      if (res && res > 0) {

        const updatedData = [...data];
        updatedData[currentPage] = {
          ...updatedData[currentPage],
          invoiceId: res,
          amountPermanentlyDropOut: dropOutAmount,
          reasonOfDroppingOut: dropOutReason,
          status: actionType as InvoiceStatus
        };
        setInvoiceIdState(res)
        setData(updatedData);


        setIsDirty(false);

        setToast({
          open: true,
          message:
            actionType == InvoiceStatus.Submitted
              ? "Invoice submitted successfully"
              : "Invoice saved as draft",
          type: "success"
        });

        if (actionType === InvoiceStatus.Submitted) {
          if (forecast) {
            navigate(`/project/edit-projects/${currentInvoice.projectId}/forecast-tracker`)
          }
          else if (currentPage === lastPage) {
            navigate('/invoicing');
          } else {
            handleNext("next");
          }
        } else {

          setIsClicked(true);
        }
      } else {
        setToast({ open: true, message: "Invoice not created", type: "error" });
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };


  const handleConfirm = () => {
    setDialogOpen(false);
    saveInvoice();
  };

  const handleChange = (event: any, newValue: number) => {
    setValue(newValue);
  };
  useEffect(() => {
    const sections = isMultiInvoiceView ? data[0]?.sections?.map(s => [s.sectionId, s.sectionName] as [number, string]) || [] : data[currentPage]?.sections?.map(s => [s.sectionId, s.sectionName] as [number, string]) || [];
    SetSection(sections);
  }, [data]);
  useEffect(() => {
    if (data.length > 0) {
      const current = isMultiInvoiceView
        ? data[0]
        : data[currentPage];

      setSummary(current?.financialSummary || null);
    }
  }, [data, currentPage, isMultiInvoiceView]);


  const handleNext = (type?: string) => {
    setIsClicked(false);
    if (isMultiInvoiceView) {
      if (type == "next") {
        setCurrentPage((prev) =>
          prev < allInvoices.length - 1 ? prev + 1 : prev
        );
      } else {
        setCurrentPage((prev) =>
          prev > 0 ? prev - 1 : prev
        );
      }
    } else {
      if (type == "next") {
        setCurrentPage((prev) =>
          prev < lastPage ? prev + 1 : prev

        );
        setDropOutAmount(0);
        setDropOutReason("");
      } else {
        setCurrentPage((prev) =>
          prev > 0 ? prev - 1 : prev
        );
      }

      const sections = isMultiInvoiceView ? data[0]?.sections?.map((s) =>
        [s.sectionId, s.sectionName] as [number, string]
      ) || [] :
        data[currentPage]?.sections?.map((s) =>
          [s.sectionId, s.sectionName] as [number, string]
        ) || [];

      SetSection(sections);
    }
  };

  const ChangeInvoiceStatusDB = async (invoiceId: number, userID: Number, Status: number, Reason: string | null) => {
    try {
      if (Status == 4 && (!Reason || Reason.trim() == "")) {
        alert("Rejection reason is required when rejecting an invoice.");
        return;
      }
      setIsSubmitting(true);
      await execute(
        "put",
        `/Invoice/update-status/${invoiceId}`
        , {
          status: Status,
          UserId: userID,
          RejectedReason: Reason
        }
      );
      setToast({
        open: true,
        message:
          Status == InvoiceStatus.Approved
            ? "Invoice Approved successfully"
            : "Invoice Rejected successfully",
        type: "success"
      });
      fetchInvoiceById(invoiceId);
    } catch (error) {
      console.error("Error fetching users", error);
    } finally {
      setIsSubmitting(false);
      setisDialogOpen(false);
    }
  }

  const [RejectedReason, setRejectedReason] = useState("");
  const [rejectSubmitAttempted, setRejectSubmitAttempted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  // const handleBackNavigation = (projectId: number) => {
  //   const stateToPass = {
  //     filterMonth: filterMonth,
  //     filterYear: filterYear
  //   };

  //   if (projectId == null) {
  //     navigate(`/invoicing`)
  //   }
  //   else if (forecast) {
  //     navigate(`/project/edit-projects/${projectId}/forecast-tracker`)
  //   }
  //   else if (invoiceIdState == 0) {
  //     navigate(`/invoicing`)
  //   }
  //   else{
  //     isSMT() ?
  //       navigate('/invoiceList') :
  //         navigate(`/invoicing/invoices/${projectId}`,{state: stateToPass})
  //   }

  // }

  const handleBackNavigation = (projectId: number) => {
    const stateToPass = {
      filterMonth: filterMonth,
      filterYear: filterYear
    };
    if (isSMT()) {
      navigate('/invoiceList');
      return;
    }
    if (projectId == null || invoiceIdState == 0) {
      navigate(`/invoicing`);
    }
    else if (forecast) {
      navigate(`/project/edit-projects/${projectId}/forecast-tracker`);
    }
    else {
      navigate(`/invoicing/invoices/${projectId}`, { state: stateToPass });
    }
  };

  return (
    <AppLayout>
      <Box sx={{ display: "flex", flexDirection: "column", height: "100%", overflow: "hidden" }}>
        <Grid2 size={{ xs: 12, md: 6, lg: 6 }} sx={{ display: 'flex', alignItems: 'center' }}>
          <IconButton sx={{ width: '40px', height: '40px', backgroundColor: 'transparent' }} onClick={() => handleBackNavigation(isMultiInvoiceView ? data[0]?.projectId : data[currentPage]?.projectId)} >
            <ArrowBackIosIcon sx={{ color: '#1e66ab', fontSize: '15px', fontWeight: 500 }} />
          </IconButton>

          <Typography sx={headingStyles}>
            {isMultiInvoiceView ? "View Invoice" : invoiceId
              ? invoiceMode == InvoiceMode.View
                ? "View Invoice"
                : "Edit Invoice"
              : "Create Invoice"}

          </Typography>
        </Grid2>
        <Box
          sx={{
            backgroundColor: "#96c121",
            height: "2px",
            border: "none",
            mb: 2
          }}
        />

        {data.length > 0 && (
          <Box sx={{
            display: "flex",
            flexDirection: "column",
            flex: 1,
            minHeight: 0,
            overflow: "hidden"
          }}>
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>

              {/* LEFT SECTION: ARROWS + HEADING */}
              <Stack direction="row" alignItems="center" spacing={1}>
                {/* LEFT ARROW */}
                {isMultiInvoiceView && (
                  <IconButton
                    onClick={() => handleNext("back")}
                    disabled={currentPage === 0}
                    sx={{
                      color: "#1e66ab", // Set the default color here
                      "&.Mui-disabled": {
                        color: "rgba(90, 113, 136, 0.3)" // Use a faded blue or your white/grey
                      },

                    }}
                  >
                    <ArrowBackIcon />
                  </IconButton>
                )}

                {/* PROJECT NAME */}
                <Typography variant="h5" sx={{ ...subHeadingStyles, whiteSpace: "nowrap" }}>
                  {isMultiInvoiceView || invoiceId
                    ? data[0].projectName
                    : data[currentPage].projectName}
                </Typography>

                {/* RIGHT ARROW */}
                {isMultiInvoiceView && (
                  <IconButton
                    onClick={() => handleNext("next")}
                    disabled={currentPage === allInvoices.length - 1}
                    sx={{
                      color: "#1e66ab",
                      p: 0.5,
                      "&.Mui-disabled": {
                        color: "rgba(90, 113, 136, 0.3)"
                      }
                    }}

                  >
                    <ArrowForwardIcon />
                  </IconButton>
                )}
              </Stack>




              {/* BUTTONS */}
              <Grid2 sx={{ display: "flex", gap: "10px" }}>

                {/* SAVE + SUBMIT */}
                {!isViewMode && (
                  <>
                    <Grid2 sx={{ width: "200px" }}>
                      <CustomButton
                        capsule
                        sx={defaultButtonStyles}
                        onClick={handleSaveInProgress}
                        disabled={!isValid || loading}
                      >
                        Save In Progress
                      </CustomButton>
                    </Grid2>

                    <Grid2 sx={{ width: "200px" }}>
                      <CustomButton
                        capsule
                        sx={defaultButtonStyles}
                        backgroundColor={"#1e66ab"}
                        hoverColor={"rgba(150, 193, 33, 0.75)"}
                        onClick={handleSaveInvoice}
                        disabled={!isValid || loading}
                      >
                        Submit
                      </CustomButton>
                    </Grid2>
                  </>
                )}

                {(isViewMode || isMultiInvoiceView) && (
                  <>
                    <Grid2 sx={{ width: "200px" }}>
                      <CustomButton
                        capsule
                        sx={defaultButtonStyles}
                        backgroundColor={"#1e66ab"}
                        hoverColor="rgba(150, 193, 33, 0.75)"
                        startIcon={<DownloadIcon />}
                        onClick={() => console.log("Export clicked")}
                      >
                        Export
                      </CustomButton>
                    </Grid2>


                  </>
                )}

                {/* APPROVE / REJECT (CONDITIONAL) */}
                {(isSMT() &&
                  ![1, 3, 4, 5].includes(
                    (isMultiInvoiceView ? data[0] : data[currentPage])?.status
                  )) && (
                    <>
                      <Grid2 sx={{ width: "200px" }}>
                        <CustomButton
                          capsule
                          sx={defaultButtonStyles}
                          startIcon={<CheckCircleIcon />}
                          onClick={() => {
                            setRejectedReason("");
                            setRejectSubmitAttempted(false);
                            setisDialogOpen(true)
                            setIsRejected(false)
                          }}
                        >
                          Approve
                        </CustomButton>
                      </Grid2>

                      <Grid2 sx={{ width: "200px" }}>
                        <CustomButton
                          capsule
                          sx={defaultButtonStyles}
                          backgroundColor={"#c62828"}
                          hoverColor={"#b71c1c"}
                          startIcon={<CancelIcon />}
                          onClick={() => {
                            setRejectedReason("");
                            setRejectSubmitAttempted(false);
                            setisDialogOpen(true)
                            setIsRejected(true)
                          }}
                        >
                          Reject
                        </CustomButton>
                      </Grid2>
                    </>
                  )}

                {/* NEXT BUTTON */}
                {isClicked && currentPage !== lastPage && (
                  <Grid2 sx={{ width: "200px" }}>
                    <CustomButton
                      capsule
                      sx={defaultButtonStyles}
                      backgroundColor={"#1e66ab"}
                      hoverColor={"rgba(150, 193, 33, 0.75)"}
                      onClick={() => handleNext("next")}
                    >
                      Next
                    </CustomButton>
                  </Grid2>
                )}

              </Grid2>

            </Box>
            <Box sx={{
              flex: 1,
              minHeight: 0,
              overflowY: "auto",
              overflowX: "hidden"
            }}>
              <Box>
                <DetailsCard Details={invoiceDetails} />
              </Box>

              <Box sx={{ display: "flex", gap: 2, mt: 2, flexWrap: "wrap" }}>
                {[
                  { label: "Instructed", value: summary?.instructed, bg: "#eef2ff", color: "#3949ab" },
                  { label: "Invoiced", value: summary?.invoiced, bg: "#e6f4ea", color: "#2e7d32" },
                  { label: "AFP Balance", value: summary?.afpBalance, bg: "#fff3e0", color: "#ef6c00" },
                  { label: "WIP Balance", value: summary?.wipBalance, bg: "#fce4ec", color: "#c2185b" },
                  { label: "Pre Billing Balance", value: summary?.preBillingBalance, bg: "#ede7f6", color: "#5e35b1" },
                  { label: "Budget Remaining", value: summary?.budgetRemaining, bg: "#e3f2fd", color: "#1565c0" },
                  { label: "Forecasted", value: summary?.forecasted, bg: "#e8f5e9", color: "#2e7d32" }
                ].map((item, i) => (
                  <Box
                    key={i}
                    sx={{
                      flex: 1,
                      minWidth: "150px",
                      p: 1.5,
                      borderRadius: "10px",

                      backgroundColor: item.bg,
                      border: "1px solid #e0e0e0",
                      boxShadow: "0px 2px 6px rgba(0,0,0,0.06)",

                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center"
                    }}
                  >
                    {/* LABEL */}
                    <Typography
                      sx={{
                        fontSize: "13px",
                        fontWeight: 500,
                        color: "#555"
                      }}
                    >
                      {item.label}
                    </Typography>

                    {/* VALUE */}
                    <Typography
                      sx={{
                        fontSize: "17px",
                        fontWeight: 600,
                        color: item.color,
                        mt: 0.5
                      }}
                    >
                      £{(item.value || 0).toLocaleString()}
                    </Typography>
                  </Box>
                ))}

              </Box>

              <Box >
                {/* ✅ SECTIONS + TABLE */}

                {(() => {

                  // ✅ ORDER: This Month first
                  const orderedSections = [
                    ...Section.filter(s => s[1] === "This Month"),
                    ...Section.filter(s => s[1] !== "This Month")
                  ];

                  // ✅ FIND SELECTED INDEX
                  const selectedIndex = orderedSections.findIndex(
                    s => s[0] === ActiveSection
                  );

                  return (
                    <>
                      {/* ✅ TABS */}
                      <Box
                        sx={{
                          width: "100%",
                          mt: 2,
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "start",
                        }}
                      >
                        <Tabs
                          value={selectedIndex === -1 ? 0 : selectedIndex}  // ✅ FIXED
                          onChange={(e, newValue) => {
                            const selected = orderedSections[newValue];
                            if (selected) {
                              SetActiveSection(selected[0]);  // ✅ CHANGE SECTION
                            }
                          }}
                          variant="scrollable"
                          scrollButtons="auto"
                          TabIndicatorProps={{ style: { display: "none" } }}
                          sx={{
                            minHeight: "auto",
                            "& .MuiTabs-flexContainer": {
                              gap: 1,
                            },
                          }}
                        >
                          {(() => {
                            const sectionIcons: Record<string, React.ReactNode> = {
                              "This Month": <CalendarMonthIcon fontSize="small" />,
                              "PO's": <ReceiptLongIcon fontSize="small" />,
                              "Instructed Works Summary": <ListAltIcon fontSize="small" />,
                              "AFP": <AccountBalanceIcon fontSize="small" />,
                              "WIP": <BuildIcon fontSize="small" />,
                              "Pre Billing": <RequestQuoteIcon fontSize="small" />,
                              "Last Month": <RequestQuoteIcon fontSize="small" />
                            };
                            return orderedSections.map((s) => (
                              <Tab
                                key={s[0]}
                                label={s[1]}
                                icon={sectionIcons[s[1]] as React.ReactElement}
                                iconPosition="start"
                                sx={{
                                  textTransform: "none",
                                  minHeight: "48px",
                                  height: "48px",
                                  px: 4,
                                  borderRadius: "25px",
                                  fontSize: "16px",
                                  fontWeight: 500,

                                  // default
                                  backgroundColor: "#ffffff",
                                  color: "#555",
                                  border: "1px solid #e0e0e0",

                                  "&:hover": {
                                    backgroundColor: "#f1f7ff",
                                  },

                                  // selected
                                  "&.Mui-selected": {
                                    backgroundColor: "#1976d2",
                                    color: "#fff",
                                    border: "1px solid #1976d2",
                                  },
                                }}
                              />
                            ));
                          })()}
                        </Tabs>
                      </Box>

                      <br />
                      <Box>

                      </Box>
                      <InvoiceFormTable
                        ActiveSection={ActiveSection}
                        data={isMultiInvoiceView ? data[0] : data[currentPage]}
                        invoiceDetails={invoiceDetails}
                        netIntoAccounts={netIntoAccounts}
                        invoiceId={invoiceIdState}
                        mode={invoiceMode}
                        onValidationChange={(valid) => setIsValid(valid)}
                        projectId={Number(ProjectID)}
                        onChange={(updated) => {
                          const currentData = isMultiInvoiceView ? data[0] : data[currentPage];

                          // Only proceed if the data is actually different
                          if (JSON.stringify(currentData) !== JSON.stringify(updated)) {
                            setData(prev => {
                              const newData = [...prev];
                              newData[currentPage] = updated;
                              return newData;
                            });
                            setIsDirty(true);
                          }
                        }}
                      />

                      {/* ✅ SINGLE TABLE (ONLY SELECTED SECTION) */}

                    </>
                  );
                })()}
              </Box>

              <Box
                sx={{
                  mt: 3,
                  p: 3,
                  borderRadius: "10px",
                  border: "1px solid #e0e0e0",
                  backgroundColor: "#f9fbff",
                  boxShadow: "0px 2px 8px rgba(0,0,0,0.06)",
                  display: "flex",
                  flexDirection: "column",
                  gap: "20px"
                }}
              >
                {/* Summary row */}
                <Box sx={{ display: "flex", gap: "40px", flexWrap: "wrap" }}>
                  <Box sx={{ display: "flex", gap: "8px", alignItems: "center" }}>
                    <Typography sx={{ fontSize: "15px", fontWeight: "bold", color: "#1e66ab" }}>
                      Net Into Accounts(N):
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "15px",
                        color: "#1e66ab",
                        backgroundColor: "#eef2ff",
                        px: 1.5,
                        py: 0.5,
                        borderRadius: "6px",
                        fontWeight: 600
                      }}
                    >
                      {(isMultiInvoiceView ? data[0] : data[currentPage]).netIntoAccounts}
                    </Typography>
                  </Box>

                  <Box sx={{ display: "flex", gap: "8px", alignItems: "center" }}>
                    <Typography sx={{ fontSize: "15px", fontWeight: "bold", color: "#1e66ab" }}>
                      Difference from Forecast:
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "15px",
                        color: "#1e66ab",
                        backgroundColor: "#eef2ff",
                        px: 1.5,
                        py: 0.5,
                        borderRadius: "6px",
                        fontWeight: 600
                      }}
                    >
                      {(isMultiInvoiceView ? data[0] : data[currentPage]).differnce}
                    </Typography>
                  </Box>
                </Box>

                {/* Divider */}
                <Box sx={{ height: "1px", backgroundColor: "#e0e0e0" }} />

                {/* Drop out fields */}
                <Box>
                  <Typography sx={{ fontSize: "15px", fontWeight: "bold", color: "#1e66ab", mb: 1 }}>
                    Any Amount Permanently Dropped Out?
                  </Typography>
                  <CustomTextField
                    label="Enter Amount"
                    name="amount"
                    type="number"
                    value={isViewMode ? data[0].amountPermanentlyDropOut : dropOutAmount}
                    disable={invoiceMode === InvoiceMode.View}
                    onChange={e => {
                      const val = Number(e.target.value);
                      if (val >= 0) setDropOutAmount(val);
                    }}
                    sx={{ width: "50%" }}
                  />
                </Box>

                <Box>
                  <Typography sx={{ fontSize: "15px", fontWeight: "bold", color: "#1e66ab", mb: 1 }}>
                    Reason for Dropping Out?
                  </Typography>
                  <CustomTextField
                    label="Enter Reason"
                    name="reason"
                    isTextArea
                    value={isViewMode || invoiceId ? data[0].reasonOfDroppingOut : dropOutReason}
                    disable={invoiceMode === InvoiceMode.View}
                    onChange={e => setDropOutReason(e.target.value)}
                    sx={{ width: "80%" }}
                  />
                </Box>




              </Box>
            </Box>



          </Box>
        )}
      </Box>

      <CustomConfirmDialog
        open={dialogOpen}
        title={
          actionType == InvoiceStatus.Draft
            ? "Confirm Save as Draft"
            : "Confirm Submit"
        }
        message={
          actionType == InvoiceStatus.Draft
            ? "Are you sure you want to Save Invoice as Draft?"
            : "Are you sure you want to Submit Invoice?"
        }
        onConfirm={handleConfirm}
        onCancel={handleCancel}
        onClose={handleCancel}
      />

      <Toaster
        open={toast.open}
        message={toast.message}
        type={toast.type as "success" | "error"}
        onClose={() => setToast({ ...toast, open: false })}
      />

      <ConfirmLeaveDialog />
      <CustomBackdrop open={loading} />
      { /* Dialog Section */}
      <Dialog
        open={isDialogOpen}
        PaperProps={{
          sx: {
            borderRadius: "16px",
            minWidth: "600px",
            overflow: "hidden",
            boxShadow: "0 8px 32px rgba(0,0,0,0.18)"
          }
        }}
      >
        {/* Coloured header strip */}
        <Box
          sx={{
            backgroundColor: isRejected ? "#c62828" : "#2e7d32",
            px: 3,
            py: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            {isRejected
              ? <CancelIcon sx={{ color: "#fff", fontSize: "24px" }} />
              : <CheckCircleIcon sx={{ color: "#fff", fontSize: "24px" }} />
            }
            <Typography sx={{ color: "#fff", fontWeight: 700, fontSize: "17px" }}>
              {isRejected ? "Reject Invoice" : "Approve Invoice"}
            </Typography>
          </Box>
          <IconButton size="small" onClick={() => setisDialogOpen(false)} sx={{ color: "#fff" }}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>

        {/* Body */}
        <Box sx={{ px: 3, pt: 3, pb: 3, display: "flex", flexDirection: "column", gap: 2 }}>
          <Typography sx={{ fontSize: "18px", fontWeight: 500, color: "#333", textAlign: "center" }}>
            {isRejected
              ? "Are you sure you want to reject this invoice?"
              : "Are you sure you want to approve this invoice?"
            }
          </Typography>

          {isRejected && (
            <TextField
              required
              fullWidth
              multiline
              minRows={3}
              label="Rejection Reason"
              placeholder="Enter reason for rejection..."
              value={RejectedReason}
              onChange={(e) => setRejectedReason(e.target.value)}
              error={rejectSubmitAttempted && RejectedReason.trim() === ""}
              helperText={rejectSubmitAttempted && RejectedReason.trim() === "" ? "Rejection reason is required" : ""}
              sx={{ mt: 1 }}
            />
          )}

          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1.5, mt: 1 }}>
            <Button
              variant="outlined"
              sx={{
                minWidth: "100px",
                fontWeight: 600,
                textTransform: "none",
                borderRadius: "8px",
                color: "#555",
                borderColor: "#ccc",
                "&:hover": { borderColor: "#999", backgroundColor: "#f5f5f5" }
              }}
              onClick={() => setisDialogOpen(false)}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              startIcon={isSubmitting ? <CircularProgress size={16} sx={{ color: "#fff" }} /> : isRejected ? <CancelIcon /> : <CheckCircleIcon />}
              disabled={isSubmitting}
              sx={{
                minWidth: "120px",
                fontWeight: 600,
                textTransform: "none",
                borderRadius: "8px",
                backgroundColor: isRejected ? "#c62828" : "#2e7d32",
                "&:hover": { backgroundColor: isRejected ? "#b71c1c" : "#1b5e20" },
                "&.Mui-disabled": { backgroundColor: isRejected ? "#e57373" : "#81c784", color: "#fff" }
              }}
              onClick={() => {
                if (isRejected) {
                  setRejectSubmitAttempted(true);
                  if (RejectedReason.trim() === "") return;
                }
                ChangeInvoiceStatusDB(
                  isMultiInvoiceView ? allInvoices[currentPage] : Number(invoiceId),
                  submittedBy,
                  isRejected ? 4 : 3,
                  isRejected ? RejectedReason : null
                );
              }}
            >
              {isSubmitting ? "Processing..." : isRejected ? "Reject" : "Approve"}
            </Button>
          </Box>
        </Box>
      </Dialog>
    </AppLayout>
  );
};

export default CreateInvoice;


